import { usePrevious } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";

import { AvatarItemRarityLevels } from "links/lib/types";
import { FullscreenRiveTakeover } from "sharedComponents/molecules/FullscreenRiveTakover";

import CapsuleMachineRive from "./resource/capsule_machine.riv";

export enum AnimationState {
  Idle = "idle",
  Click = "click",
  TicketFall = "ticket fall",
  Loading = "loading",
  PrizeR1 = "prize_rar1",
  PrizeR2 = "prize_rar2",
  PrizeR3 = "prize_rar3",
  PrizeR4 = "prize_rar4",
  PrizeR5 = "prize_rar5",
}

interface IProps {
  show: boolean;
  handleEnd: () => void;
  rarity: AvatarItemRarityLevels;
}

const getItemRarityAnimation = (
  rarity: AvatarItemRarityLevels
): AnimationState => {
  switch (rarity) {
    case AvatarItemRarityLevels.Level1:
      return AnimationState.PrizeR1;
    case AvatarItemRarityLevels.Level2:
      return AnimationState.PrizeR2;
    case AvatarItemRarityLevels.Level3:
      return AnimationState.PrizeR3;
    case AvatarItemRarityLevels.Level4:
      return AnimationState.PrizeR4;
    case AvatarItemRarityLevels.Level5:
      return AnimationState.PrizeR5;
    default:
      return AnimationState.PrizeR1;
  }
};

// This is not a complete sequence of animations created for capsule machine
// This is what could be made to work correctly
export const CapsuleMachineAnimation: React.FC<IProps> = ({
  show,
  rarity,
  handleEnd,
}: IProps) => {
  const [animationState, setAnimationState] = useState(AnimationState.Idle);
  const prevShow = usePrevious(show);

  useEffect(() => {
    if (show && !prevShow) {
      setAnimationState(AnimationState.Click);
      setTimeout(() => {
        setAnimationState(AnimationState.Loading);
        setTimeout(() => {
          setAnimationState(getItemRarityAnimation(rarity));
          setTimeout(() => {
            handleEnd();
            setAnimationState(AnimationState.Idle);
          }, 2500);
        }, 4500);
      }, 1000);
    }
  }, [show, prevShow, rarity, handleEnd]);

  return (
    <FullscreenRiveTakeover
      show={show}
      bgColor="#313131"
      src={CapsuleMachineRive}
      stateMachines="Capsule Machine Build"
      animations={animationState}
      animatedBoxProps={{
        position: "absolute",
        borderRadius: "xl",
      }}
    />
  );
};
